var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.01984 12.4322L5.01142 12.46L5.03449 12.4424L8.02881 10.1592L11.0231 12.4424L11.0462 12.46L11.0378 12.4322L9.91473 8.72616L12.9092 6.59257L12.9331 6.57556H12.9038H9.23573L8.03777 2.68218L8.02881 2.65306L8.01985 2.68218L6.82188 6.57556H3.15381H3.12449L3.14837 6.59257L6.14288 8.72616L5.01984 12.4322ZM8.02881 15.4256C6.99253 15.4256 6.0188 15.2289 5.10752 14.8357C4.19607 14.4424 3.40332 13.9087 2.72919 13.2346C2.05506 12.5604 1.52134 11.7677 1.12804 10.8562C0.73482 9.94495 0.538184 8.97122 0.538184 7.93494C0.538184 6.89866 0.73482 5.92493 1.12804 5.01365C1.52134 4.10219 2.05506 3.30944 2.72919 2.63532C3.40332 1.96119 4.19607 1.42747 5.10752 1.03417C6.0188 0.640948 6.99253 0.444312 8.02881 0.444312C9.06509 0.444312 10.0388 0.640948 10.9501 1.03417C11.8616 1.42747 12.6543 1.96119 13.3284 2.63532C14.0026 3.30944 14.5363 4.10219 14.9296 5.01365C15.3228 5.92493 15.5194 6.89866 15.5194 7.93494C15.5194 8.97122 15.3228 9.94495 14.9296 10.8562C14.5363 11.7677 14.0026 12.5604 13.3284 13.2346C12.6543 13.9087 11.8616 14.4424 10.9501 14.8357C10.0388 15.2289 9.06509 15.4256 8.02881 15.4256Z",
    fill: "#55AE7B",
    stroke: "#55AE7B",
    strokeWidth: 0.01875
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.66a442811b32dc709e978200238a245a.svg";
export { ForwardRef as ReactComponent };